/*
 * Server detail view Stats tab
 */

(function (__module__, c2) {
  'use strict';

  var logger = c2.logging.getLogger(__module__);
  var chartSettings = {};
  var allServerEvents = [];

  function init(settings) {
    logger.debug('init called with settings: ', settings);
    var now = (new Date()).getTime();

    // Store data so drawCharts can use it
    chartSettings = settings;
    // chartSettings.startTime = now - (chartSettings.interval * chartSettings.points  * 1000)
    // Rather than considering the machine's local time to calculate the start time of the graph we're considering last refreshed time to calculate the start time
    // We're passing that value while initialising the Highchart graph


    var $historyTable = $('#history');
    if ($historyTable.data('table-source') !== undefined) {
      // History table has been initialized. User must have chosen a different
      // date range. Redraw the new charts.
      drawCharts();
    }
  }


  // Called in c2.history.loadHistoryData once server history events are loaded
  function drawCharts(historyEvents) {
    logger.debug('drawCharts\n  chartSettings: ', chartSettings);

    if (chartSettings && chartSettings.cpuValues === undefined) {
      logger.debug('This server has no stats, so not drawing charts.')
      return;
    }

    if (historyEvents) {
      // Store these so we can use them from now on as the user requests
      // different date ranges.
      allServerEvents = historyEvents;
    }

    // use just the events that happened at or after startTime
    var serverEvents = _.filter(allServerEvents, function(event) {
        return event.epoch_ms >= chartSettings.startTime;
    });
    logger.debug('  serverEvents:', serverEvents);

    Highcharts.setOptions({
        global: {
            useUTC: false
        }
    });

    c2.chartsServerStats.drawServerCPUStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.cpuValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackCPUStatChartOpts : c2.chartsServerStats.commonStatChartOpts,
      chartSettings.openstackTitleFlag);

    c2.chartsServerStats.drawServerMemStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.memValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackMemStatChartOpts : c2.chartsServerStats.commonStatChartOpts,
      chartSettings.openstackTitleFlag);

    c2.chartsServerStats.drawServerDiskStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.diskValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackDiskStatChartOpts : c2.chartsServerStats.diskStatChartOpts,
      chartSettings.openstackTitleFlag);

    c2.chartsServerStats.drawServerDiskWriteStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.diskwriteValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackDiskStatChartOpts : c2.chartsServerStats.diskStatChartOpts,
      chartSettings.openstackTitleFlag);

    c2.chartsServerStats.drawServerNetStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.netValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackNetStatChartOpts : c2.chartsServerStats.netStatChartOpts,
      chartSettings.openstackTitleFlag);

    c2.chartsServerStats.drawServerNetOutgoingStatsChart(
      chartSettings.startTime,
      chartSettings.interval,
      chartSettings.netOutgoingValues,
      serverEvents,
      chartSettings.openstackTitleFlag ? c2.chartsServerStats.openstackNetStatChartOpts : c2.chartsServerStats.netStatChartOpts,
      chartSettings.openstackTitleFlag);
  }


  c2[__module__] = {
    init: init,
    drawCharts: drawCharts
  };
})('serverStats', window.c2);
